import { useContext } from "react";
import styles from "./FamilyCard.module.scss";
import card_main_image from "./images/card_main_image.png";
import Barcode from "react-barcode";

import { AuthContext } from "../../Contexts/AuthContext";

const FamilyCard = () => {
  const { user } = useContext(AuthContext);

  return (
    <div className={styles.family_card}>
      <img
        className={styles.desi_card_main_img}
        src={"/df_card.png"}
        alt="card_main_image"
      />
      <div className={styles.barcode}>
        {user.reward_card_number ? (
          <Barcode
            value={user.reward_card_number}
            lineColor="white"
            background="transparent"
            width={2}
            height={50}
          />
        ) : (
          <Barcode
            value="123456789012345"
            lineColor="white"
            background="transparent"
            width={2}
            height={50}
          />
        )}
      </div>
      <span className={styles.name}>
        {!user.reward_card_number
          ? "Guest User"
          : user.title + " " + user.first_name + " " + user.last_name}
      </span>
    </div>
  );
};

export default FamilyCard;
